var _mask, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1781_7929",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H50H0ZM50 50.5H0H50ZM0 50.5V0.5V50.5ZM26 0.5C39.8071 0.5 51 11.6929 51 25.5C51 39.3071 39.8071 50.5 26 50.5H25C38.2548 50.5 49 39.3071 49 25.5C49 11.6929 38.2548 0.5 25 0.5H26Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1781_7929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.314 36.4125L20.3909 29.175H36.7001L32.6227 36.4125H16.314Z",
    fill: "#3777E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5455 29.175H36.6998L28.5455 14.7H20.3906L28.5455 29.175Z",
    fill: "#FFCF63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2363 29.175L16.3138 36.4125L24.4681 21.9375L20.3908 14.7L12.2363 29.175Z",
    fill: "#11A861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.20c71e3a71961326c7654037017e125a.svg";
export { ForwardRef as ReactComponent };